<div class="page-container unified">
  <div class="no-cdr-required-content-container">
    <div class="no-cdr-required-decoration-container col-12">
      <div class="content">
        <app-background-decoration></app-background-decoration>

        <div class="display-content">
          <h3>
            Based on your current selections, a RightBRIDGE Client Detail Report
            (CDR) is not required.
          </h3>
        </div>
      </div>
    </div>
  </div>
</div>
